import apiClient from "../api/axiosConfig";
import { ENDPOINTS } from "../api/endpoints";
import { ApiResponse, NotificationSyncResponse } from "../../types/api.types";

export const syncService = {
  getNotification: async (
    token: string = "",
  ): Promise<NotificationSyncResponse> => {
    const response = await apiClient.get<ApiResponse<NotificationSyncResponse>>(
      ENDPOINTS.SYNC.GET_NOTIFICATIONS,
      {
        ...(token && { headers: { Authorization: `Bearer ${token}` } }),
      },
    );
    return response.data.data;
  },
};
